import { jwtDecode } from "jwt-decode";
import { Useprovider } from "./stateManagementAPi";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NotificationServices from "./topnavServices";
import { truncateName25, truncateName40 } from "../helper/StringSlicer";
import { formatDateWithTime } from "../helper/DateFormater";
import UserService from "./UserService";
import { useTranslation } from "react-i18next";

const TopNav = () => {
  // const [notificationCount, setNotificationCount] = useState();
  const { t } = useTranslation();
  const [notification, setNotification] = useState([]);
  const [notificationCount, setNotificaionCount] = useState(0);
  const [notificationData, setNotificationData] = useState({});
  const token = localStorage.getItem("token");
  const jwt = token ? jwtDecode(token) : null;
  const userId = jwt?.id;
  const companyId = jwt?.companyId;
  console.log("token_user_Id", userId);

  //  const jwt = jwtDecode(localStorage.getItem("token"));
  const navigate = useNavigate();
  const { path } = useContext(Useprovider);
  const role = jwt?.role[0]?.name;
  console.log("jwt_role", role);
  function logOut() {
    localStorage.removeItem("token");
    if (localStorage.getItem("token") == null) {
      navigate("/login");
    }
  }

  //get notification
  const getNotification = () => {
    NotificationServices.getNotification(companyId)
      .then((response) => {
        const data = response.data.data.notificationList;
        setNotification(data);
        setNotificaionCount(response.data.data.notificationCount);
        console.log("setNotification", data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleNotification = (id) => {
    debugger;
    NotificationServices.findNotificationById(id)
      .then((response) => {
        setNotificationData(response.data.data);
        getNotification();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const [userData, setUserData] = useState({});

  const getUser = () => {
    UserService.getUser(userId).then((response) => {
      setUserData(response.data.data);
    });
  };

  useEffect(() => {
    getNotification();
    getUser();
  }, []);

  return (
    <>
      {jwt !== null ? (
        <header className="top-header">
          <nav className="navbar navbar-expand">
            <div className="mobile-toggle-icon d-xl-none">
              <i className="bi bi-list"></i>
            </div>
            <div className="row width-100">
              <div className="col-6 col-lg-6 col-xl-6">
                {/* <div className="search-toggle-icon d-xl-none m-lg-0 m-2">
                  <i className="bi bi-search"></i>
                </div> */}
                {/* <form className="searchbar d-none d-xl-flex">
                  <div className="position-absolute top-50 translate-middle-y search-icon ms-3">
                    <i className="bi bi-search"></i>
                  </div>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search workers, companies..."
                  />
                  <div className="position-absolute top-50 translate-middle-y d-block d-xl-none search-close-icon">
                    <i className="bi bi-x-lg"></i>
                  </div>
                </form> */}
              </div>

              <div className="col-6 col-lg-6 col-xl-6">
                <div className="top-navbar-right ms-3 float-right">
                  <ul className="navbar-nav align-items-center">
                    <li className="nav-item dropdown dropdown-large">
                      <a
                        className="nav-link dropdown-toggle dropdown-toggle-nocaret"
                        href="#"
                        data-bs-toggle="dropdown"
                      >
                        <div className="notifications">
                          <span className="notify-badge">
                            {notificationCount}
                          </span>
                          <i className="bi bi-bell-fill"></i>
                        </div>
                      </a>
                      <div className="dropdown-menu dropdown-menu-end p-0">
                        <div className="p-2 border-bottom m-2">
                          <h5 className="h5 mb-0">Notifications</h5>
                        </div>
                        <div className="header-notifications-list p-2 mb-2">
                          {notification.slice(0, 6).map(
                            (
                              item // Limit to the first five notifications
                            ) => (
                              <a
                                key={item.id} // Ensure each element has a unique key
                                className={`dropdown-item p-2 mb-1 pe-auto ${
                                  item.status === "RECEIVED" ? "active-bg" : "" // Check if status is "RECEIVED"
                                }`}
                                onClick={() => handleNotification(item.id)}
                              >
                                <div className="d-flex align-items-center">
                                  <div className="notification-box">
                                    <i className="bi bi-people-fill"></i>
                                  </div>
                                  <div className="ms-2 flex-grow-1 w-90">
                                    <p
                                      className="mb-0 dropdown-msg-user font_12"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {item?.title}
                                      <span
                                        title="2023-01-12 11:54:14Z"
                                        className="relativetime float-end font_11" // Corrected class to className
                                      >
                                        {formatDateWithTime(item.timestamp)}
                                      </span>
                                    </p>
                                    <small
                                      className="mb-0 dropdown-msg-text text-secondary d-flex align-items-center font_10"
                                      style={{ whiteSpace: "break-spaces" }}
                                    >
                                      {truncateName40(item?.description)}
                                    </small>
                                  </div>
                                </div>
                              </a>
                            )
                          )}
                        </div>
                        <div className="p-2">
                          <div>
                            <hr className="dropdown-divider" />
                          </div>
                          {(role === "ROLE_WORKER" ||
                            role === "ROLE_SUPERVISOR") && (
                            <a
                              className="dropdown-item text-center"
                              href="/dashboard/supervisor/notification"
                            >
                              View All Notifications
                            </a>
                          )}

                          {role === "ROLE_ADMIN" && (
                            <a
                              className="dropdown-item text-center"
                              href="/dashboard/company/notification"
                            >
                              View All Notifications
                            </a>
                          )}
                          {role === "ROLE_SUPERADMIN" && (
                            <a
                              className="dropdown-item text-center"
                              href="/dashboard/admin/notification"
                            >
                              View All Notifications
                            </a>
                          )}
                        </div>
                      </div>
                    </li>
                    <li className="nav-item dropdown dropdown-large">
                      <a
                        className="nav-link dropdown-toggle dropdown-toggle-nocaret"
                        href="#"
                        data-bs-toggle="dropdown"
                      >
                        <div className="user-setting d-flex align-items-center gap-1">
                          <img
                            src={userData.imageUrl}
                            className="user-img"
                            alt="userimage"
                            onError={(e) => {
                              e.target.onerror = null; // To prevent infinite loops in case the default image also fails
                              e.target.src =
                                "https://www.pngitem.com/pimgs/m/150-1503945_transparent-user-png-default-user-image-png-png.png"; // Set the URL of the default image here
                            }}
                          />
                          <div className="user-name">{userData.name}</div>
                        </div>
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end">
                        <li>
                          <a className="dropdown-item">
                            <div className="d-flex align-items-center profile-image-custom">
                              <img
                                src={userData.imageUrl}
                                alt="userimage"
                                // className="rounded-circle"
                                style={{ borderRadius: "50%" }}
                                width="60"
                                height="60"
                                onError={(e) => {
                                  e.target.onerror = null; // To prevent infinite loops in case the default image also fails
                                  e.target.src =
                                    "https://www.pngitem.com/pimgs/m/150-1503945_transparent-user-png-default-user-image-png-png.png"; // Set the URL of the default image here
                                }}
                              />
                              <div className="ms-3">
                                <h6 className="mb-0 dropdown-user-name">
                                  {userData.name}
                                </h6>
                                {userData.userType === "worker" ? (
                                  <small className="mb-0 dropdown-user-designation text-secondary">
                                    You are not authorize
                                  </small>
                                ) : (
                                  <small className="mb-0 dropdown-user-designation text-secondary">
                                    {userData.userType}
                                  </small>
                                )}
                              </div>
                            </div>
                          </a>
                        </li>
                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        {role == "ROLE_SUPERADMIN" || role == "ROLE_ADMIN" ? (
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/dashboard/company/changepassword"
                              state={{ userName: jwt.username }}
                            >
                              <div className="d-flex align-items-center">
                                <div className="setting-icon">
                                  <i className="bi bi-repeat fill"></i>
                                </div>
                                <div className="setting-text ms-3">
                                  <span>{t("Change_Password")}</span>
                                </div>
                              </div>
                            </Link>
                          </li>
                        ) : (
                          <>
                            <li>
                              <a
                                className="dropdown-item"
                                href="/dashboard/supervisor/myProfile"
                              >
                                <div className="d-flex align-items-center">
                                  <div className="setting-icon">
                                    <i className="bi bi-person-fill"></i>
                                  </div>
                                  <div className="setting-text ms-2">
                                    <span>Profile</span>
                                  </div>
                                </div>
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="/dashboard/supervisor/settings"
                              >
                                <div className="d-flex align-items-center">
                                  <div className="setting-icon">
                                    <i className="bi bi-gear-fill"></i>
                                  </div>
                                  <div className="setting-text ms-2">
                                    <span>Settings</span>
                                  </div>
                                </div>
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="/dashboard/supervisor/changepassword"
                              >
                                <div className="d-flex align-items-center">
                                  <div className="setting-icon ">
                                    <i className="bi bi-repeat fill"></i>
                                  </div>
                                  <div className="setting-text ms-2">
                                    <span>{t("Change_Password")}</span>
                                  </div>
                                </div>
                              </a>
                            </li>

                            <li>
                              <hr className="dropdown-divider" />
                            </li>
                          </>
                        )}
                        <li>
                          <button className="dropdown-item" onClick={logOut}>
                            <div className="d-flex align-items-center">
                              <div className="setting-icon">
                                <i className="bi bi-lock-fill"></i>
                              </div>
                              <div className="setting-text ms-3">
                                <span>{t("Logout")}</span>
                              </div>
                            </div>
                          </button>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </header>
      ) : null}
    </>
  );
};

export default TopNav;
